export default __webpack_public_path__ + "static/icon-linkedin-color-b44646dcf8d5b57949338b37ce7a7dcb.svg";